import type { AddProductItemSopSection } from "../types";

export const ADD_PRODUCT_ITEM_SOP_SECTIONS: AddProductItemSopSection[] = [
  {
    id: "before-you-start",
    titleKey: "add-product-item-sop-before-start-title",
    titleFallback: "Before you start",
    steps: [
      {
        bodyKey: "add-product-item-sop-before-start-1",
        bodyFallback:
          "Sign in and go to Portal → Inventory → Products. You need permission to manage products and stock."
      },
      {
        bodyKey: "add-product-item-sop-before-start-2",
        bodyFallback:
          "A product item is a stock record for an existing product. Create the product in your catalog first, then add items to record quantity, pricing, and a QR label for each stock row."
      },
      {
        bodyKey: "add-product-item-sop-before-start-3",
        bodyFallback:
          "Adding items uses a three-step wizard: Details → Quantity → QR codes. The fields in step 1 depend on the product's selling mode. You can create up to 50 item rows in one batch; each row gets its own ID and QR code."
      }
    ]
  },
  {
    id: "open-product",
    titleKey: "add-product-item-sop-open-product-title",
    titleFallback: "Open the product",
    steps: [
      {
        bodyKey: "add-product-item-sop-open-product-1",
        bodyFallback:
          "On the Products list, find the product you want to stock. Use Filters or search if your catalog is large.",
        imageId: "products-list"
      },
      {
        bodyKey: "add-product-item-sop-open-product-2",
        bodyFallback:
          "Click the blue eye icon in the Actions column to open the product details page."
      }
    ]
  },
  {
    id: "product-items-tab",
    titleKey: "add-product-item-sop-product-items-tab-title",
    titleFallback: "Open the Product Items tab",
    steps: [
      {
        bodyKey: "add-product-item-sop-product-items-tab-1",
        bodyFallback:
          "On the product details page, select the Product Items tab. This tab lists every stock row for the product, including status and QR code.",
        imageId: "product-items-tab"
      },
      {
        bodyKey: "add-product-item-sop-product-items-tab-2",
        bodyFallback:
          "Use Search items or the Status filter to find existing stock lines. When you are ready to receive new stock, click the purple + Add Item button."
      }
    ]
  },
  {
    id: "wizard-details",
    titleKey: "add-product-item-sop-wizard-details-title",
    titleFallback: "Step 1: Details",
    steps: [
      {
        bodyKey: "add-product-item-sop-wizard-details-1",
        bodyFallback:
          "The Add New Product Item wizard opens with three steps. On Details, enter Total Quantity (units of stock inside each row). For Single Item products, quantity is always 1. Base unit is inherited from the product catalog.",
        imageId: "wizard-details"
      },
      {
        bodyKey: "add-product-item-sop-wizard-details-2",
        bodyFallback:
          "In Identifiers & Pricing, enter Variation Name (often the product name or a size/color label), Purchase Price, Sales Price, and Min Sales Price. Fields marked with * are required."
      },
      {
        bodyKey: "add-product-item-sop-wizard-details-3",
        bodyFallback:
          "Scroll down to optionally fill Physical Attributes and Dates & Lot for traceability. When Details is complete, click Next."
      }
    ]
  },
  {
    id: "wizard-quantity",
    titleKey: "add-product-item-sop-wizard-quantity-title",
    titleFallback: "Step 2: Quantity",
    steps: [
      {
        bodyKey: "add-product-item-sop-wizard-quantity-1",
        bodyFallback:
          "Enter Number of item rows — how many separate stock lines to create. Each row gets one unique ID and QR code; this count is not multiplied by the quantity per row. You can create up to 50 rows per batch.",
        imageId: "wizard-quantity"
      },
      {
        bodyKey: "add-product-item-sop-wizard-quantity-2",
        bodyFallback:
          "Review the summary box (variation name, prices, units per row, and total inventory). Click Create N items to save."
      }
    ]
  },
  {
    id: "qr-codes",
    titleKey: "add-product-item-sop-qr-codes-title",
    titleFallback: "Step 3: QR codes",
    steps: [
      {
        bodyKey: "add-product-item-sop-qr-codes-1",
        bodyFallback:
          "After the batch is saved, the QR Codes Generated window appears with a unique code for each row created. Use Print to send labels to your printer.",
        imageId: "qr-codes"
      },
      {
        bodyKey: "add-product-item-sop-qr-codes-2",
        bodyFallback:
          "Click Add More Items to run the wizard again for the same product, or Done to return to the Product Items list. New rows appear in the table with status In stock."
      }
    ]
  }
];
